import { Typography, Card, CardContent, useTheme } from "@mui/material";

import AnimatedImage from "@/components/UI-Kit/AnimatedImage";
import { getCardStyles, imageContainerStyles } from "./styles";

interface IProps {
  title: string;
  description: string;
  imageUrl: string;
  thumbnail: string;
  maxWidth?: number;
}

const BenefitCard: React.FC<IProps> = ({
  title,
  description,
  imageUrl,
  thumbnail,
  maxWidth,
}) => {
  const theme = useTheme();

  return (
    <Card variant="outlined" sx={getCardStyles(theme)}>
      {/* Description */}
      <CardContent sx={{ padding: "0 !important" }}>
        <Typography
          variant="h4"
          component="h3"
          color="text.primary"
          mb={{ xs: 1, md: 2 }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          fontSize={{ sm: 16 }}
        >
          {description}
        </Typography>
      </CardContent>

      {/* Image */}
      <AnimatedImage
        sx={{
          ...imageContainerStyles,
          maxWidth: maxWidth ? maxWidth : "100%",
        }}
        thumbnailUrl={thumbnail}
        mainUrl={imageUrl}
        alt={title}
      />
    </Card>
  );
};
export default BenefitCard;
